import styled from 'styled-components';
import theme from 'styles/theme';

export const RequiredSign = styled.span`
  color: ${theme.colors.red};
`;
